import { PriceStatus } from '@/api/models/PriceStatus';
import { themeColors } from '@/theme/colors';
import { Select } from '@chakra-ui/react';

type PriceStatusSelectProps = {
  value: PriceStatus;
  onChange: (status: PriceStatus) => void;
};

const PriceStatusSelect = ({ value, onChange }: PriceStatusSelectProps) => {
  return (
    <Select
      variant="unstyled"
      value={value}
      onChange={(e) => onChange(e.target.value as PriceStatus)}
      color={themeColors.support.warning.default}
      className="body-md-regular"
      cursor="pointer"
      icon={<span />}
      sx={{
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        background: 'transparent',
        border: 'none',
        padding: 0,
        margin: 0,
        height: 'auto',
        minHeight: 'unset',
        lineHeight: 'inherit',
        fontSize: 'inherit',
      }}
    >
      <option value={PriceStatus.Approved}>A</option>
      <option value={PriceStatus.Preliminary}>P</option>
    </Select>
  );
};

export default PriceStatusSelect;
